<ng-template #filterLabelTmpl let-index="index">
  @switch (index) {
    @case (0) {
      <rt-heading variant="subheading" class="subheading">
        <span padding-left-small-x>{{ 'app.views.filters.where' | translate }}</span>
      </rt-heading>
    }
    @case (1) {
      <rt-select2
        #select
        [items]="filterOperatorsItems"
        [formControl]="filterForm.controls.operator"
        [overlayWidth]="100"
        (uiItemSelect)="onOperatorSelect($event)"
      >
        <ng-container *rtSelectTrigger="select; let selectCtrl">
          <rt-button
            [dropdownOpened]="selectCtrl.isOpen()"
            (click)="selectCtrl.toggle(true)"
            variant="plain"
            >{{ selectCtrl.itemSelector.selected()?.label }}</rt-button
          >
        </ng-container>
      </rt-select2>
    }
    @default {
      <div class="label-disabled">
        <span class="label-container">
          {{ filterOperators[filterForm.controls.operator.value] }}
        </span>
      </div>
    }
  }
</ng-template>

<div layout layout-align-items-center>
  <rt-heading variant="heading large">{{ 'app.views.filters.all_filters' | translate }}</rt-heading>
  <span margin-left-small-x text-small text-light>
    {{ 'app.views.filters.results_count' | translate: { count: viewsRecordsTotalCount } }}
  </span>
  <a rt-button [rtHelpArticle]="helpArticleLink" variant="plain" size="small" margin-left-auto>
    <rt-icon name="help-outline"></rt-icon>
    {{ 'app.common.learn_more' | translate }}
  </a>
</div>
@if (filterData.length) {
  <div layout margin-top-small>
    <div class="filters-container">
      @for (data of filterData; track data.filterUuid; let index = $index) {
        <div layout margin-bottom-small>
          <div class="label">
            <ng-template
              [ngTemplateOutlet]="filterLabelTmpl"
              [ngTemplateOutletContext]="{ index }"
            />
          </div>
          <views-filter
            [dataSourceId]="(dataSourceId$ | ngrxPush)!"
            [filterControl]="data.filterControl"
            [filterUuid]="data.filterUuid"
            [filterDef]="data.filterDef"
            [filterState]="data.filterState"
            [filterInputDefs]="data.filterInputDefs"
            (filterStateChanges)="onFilterStateChanges(data.filterUuid, $event)"
          />
          <rt-icon-button
            class="remove-filter"
            iconName="close"
            variant="plain"
            (click)="onFilterRemove(data.filterControl)"
          ></rt-icon-button>
        </div>
      }
      <div class="filters-controls">
        <rt-views-filter-select trigger="button" (filterChange)="onFilterSelect($event)" />
        <rt-button variant="plain" (click)="clearFilters()">
          {{ 'app.views.filters.clear_filters' | translate }}
        </rt-button>
      </div>
    </div>
  </div>
}
@if (!filterForm.controls.filters.length) {
  <rt-empty-state
    [icon]="'filter-list'"
    [title]="'app.views.filters.empty_state_title' | translate"
    [desc]="'app.views.filters.empty_state_description' | translate"
    padding
  >
    <rt-button (click)="addFilter()">
      <rt-icon name="add"></rt-icon>
      {{ 'app.views.filters.add_filter' | translate }}
    </rt-button>
  </rt-empty-state>
}
